<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-uppercase" id="myLargeModalLabel">Add New Unit</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <p class="fw-bold text-black text-uppercase">Unit Details:</p>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Unit Number <span class="text-danger">*</span></label>
                <input v-model="formData.unitNo" type="text" class="form-control" placeholder="Enter the Unit Number">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Unit Type <span class="text-danger">*</span></label>
                <select v-model="formData.category" class="form-select">
                  <option value="">Select Unit Type</option>
                  <option v-for="category in unitCategories" :key="category.id" :value="category.category">
                    {{ category.category }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Monthly Rent <span class="text-danger">*</span></label>
                <input v-model="formData.monthlyRent" type="number" class="form-control" placeholder="Enter Monthly Rent">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Occupant Name</label>
                <input v-model="formData.occupants" type="text" class="form-control" placeholder="Enter Occupant Name (Optional)">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Phone Number</label>
                <input v-model="formData.phoneNumber" type="text" class="form-control" placeholder="Enter Phone Number (Optional)">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>ID Number</label>
                <input v-model="formData.idNo" type="text" class="form-control" placeholder="Enter ID Number (Optional)">
              </div>
            </div>

            <div class="col-12">
              <div class="form-group mb-3">
                <label>Initial Arrears</label>
                <input v-model="formData.arrears" type="number" class="form-control" placeholder="Enter Initial Arrears (Default: 0)">
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button
              @click="submitUnit"
              type="button"
              class="btn btn-primary waves-effect waves-light"
              :disabled="!isFormValid || submitting"
          >
            <span v-if="submitting">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Adding...
            </span>
            <span v-else>
              <i class="bx bx-check font-size-16 align-middle me-2"></i> Add Unit
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { execute, rent } from "@/api";

export default {
  name: "AddUnitModal",
  props: {
    modalId: {
      type: String,
      default: "add-unit-modal"
    },
    property: {
      type: Object,
      default: () => ({})
    },
    unitCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      submitting: false,
      formData: {
        unitNo: '',
        category: '',
        monthlyRent: '',
        occupants: '',
        phoneNumber: '',
        idNo: '',
        arrears: '0'
      }
    };
  },
  computed: {
    isFormValid() {
      return this.formData.unitNo &&
          this.formData.category &&
          this.formData.monthlyRent &&
          Number(this.formData.monthlyRent) > 0;
    }
  },
  methods: {
    resetForm() {
      this.formData = {
        unitNo: '',
        category: '',
        monthlyRent: '',
        occupants: '',
        phoneNumber: '',
        idNo: '',
        arrears: '0'
      };
    },

    submitUnit() {
      if (!this.isFormValid) {
        alert("Please fill all required fields");
        return;
      }

      this.submitting = true;

      const data = new FormData();
      data.append("function", "addUnit");
      data.append("propertyID", this.property.propertyID || sessionStorage.getItem("propertyID"));
      data.append("property", this.property.property);
      data.append("unitNo", this.formData.unitNo);
      data.append("category", this.formData.category);
      data.append("monthlyRent", this.formData.monthlyRent);
      data.append("occupants", this.formData.occupants);
      data.append("phoneNumber", this.formData.phoneNumber);
      data.append("idNo", this.formData.idNo);
      data.append("arrears", this.formData.arrears || '0');
      data.append("subCountyID", this.property.subCountyID);
      data.append("subCountyName", this.property.subCountyName);
      data.append("wardID", this.property.wardID);
      data.append("wardName", this.property.wardName);
      data.append("zone", this.property.zone || '');
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, rent)
          .then((res) => {
            this.submitting = false;
            if (res.data.success) {
              alert("Unit added successfully!");
              this.$emit('unit-added');

              // Close modal
              const modal = window.bootstrap.Modal.getInstance(document.getElementById(this.modalId));
              if (modal) modal.hide();

              // Reset form
              this.resetForm();
            } else {
              alert(res.data.message || "Failed to add unit");
            }
          })
          .catch((e) => {
            this.submitting = false;
            alert("Error: " + e.message);
          });
    }
  }
};
</script>

<style scoped>
.text-danger {
  color: #dc3545;
}
</style>